import { LayoutDashboard, FileText, Settings, HelpCircle, LogOut, CreditCard } from "lucide-react";
import { User } from "lucide-react";

export const mainNavItems = [
	{
		id: "dashboard", label: "Document Center", icon: <LayoutDashboard className="w-4 h-4" />, path: "/dashboard", tooltip: "Create, upload and manage your documents." },
	{ id: "documents", label: "My Documents", icon: <FileText className="w-4 h-4" />, path: "/my-documents", tooltip: "Browse, search and manage all your documents." },
];

export const otherNavItems = [
  { id: "settings", label: "Settings", icon: <Settings className="w-4 h-4" />, tooltip: "Update your profile, preferences, and account details.",
    		children: [
			{
				id: 'profile',
				label: 'Profile',
				icon: <User className="w-4 h-4" />,
			},
			{
				id: 'security',
				label: 'Security',
				icon: (
					<svg
						width="16"
						height="17"
						viewBox="0 0 16 17"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M8 1.1665L2 3.83317V7.83317C2 11.5332 4.56 14.9932 8 15.8332C11.44 14.9932 14 11.5332 14 7.83317V3.83317L8 1.1665ZM8 5.1665C8.93333 5.1665 9.86667 5.89984 9.86667 6.83317V7.83317C10.2667 7.83317 10.6667 8.23317 10.6667 8.69984V11.0332C10.6667 11.4332 10.2667 11.8332 9.8 11.8332H6.13333C5.73333 11.8332 5.33333 11.4332 5.33333 10.9665V8.63317C5.33333 8.23317 5.73333 7.83317 6.13333 7.83317V6.83317C6.13333 5.89984 7.06667 5.1665 8 5.1665ZM8 5.9665C7.46667 5.9665 7 6.29984 7 6.83317V7.83317H9V6.83317C9 6.29984 8.53333 5.9665 8 5.9665Z"
							fill="#180A63"
						/>
					</svg>
				),
			}
		]
	},
	{
		id: "subscription", label: "Subscription", icon: <CreditCard className="w-4 h-4" />, path: "/subscription", tooltip: "View and manage your subscription plan." },
	{
		id: "help", label: "Support", icon: <HelpCircle className="w-4 h-4" />, path: "/help", tooltip: "Report an issue or request help from the WriteForm team." },
  { id: "logout", label: "Logout", icon: <LogOut className="w-4 h-4" />, variant: "danger", path: "/login", tooltip: "Sign out of WriteForm safely." },
];
